import { css } from 'lit';

export const styles = css`
  #materials-block {
    display: inline-grid;
    grid-template-columns: repeat(1, minmax(0, auto));
    flex-direction: column;
    width: 100%;
    gap: var(--between-column-padding);
    padding-top: var(--top-padding-height);
    margin-top: var(--top-padding-height);
    border-top: 1px solid #cccccc;

    .column {
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      flex-grow: 1;
      gap: calc(14rem / var(--default-rem-px-count));
      min-width: calc(240rem / var(--default-rem-px-count));
      padding-bottom: calc(20rem / var(--default-rem-px-count));
      margin-bottom: calc(20rem / var(--default-rem-px-count));

      .column-content {
        display: flex;
        flex-direction: column;
        gap: calc(14rem / var(--default-rem-px-count));
        width: 100%;
      }
    }

    h2 {
      font-size: calc(24rem / var(--default-rem-px-count));
      font-weight: 400;
      letter-spacing: -0.72px;
    }

    h3 {
      font-size: calc(18rem / var(--default-rem-px-count));
      font-weight: 400;
      line-height: calc(24rem / var(--default-rem-px-count));
      letter-spacing: -0.54px;
      margin-top: calc(-10rem / var(--default-rem-px-count));
    }

    h4 {
      margin: 0;
      font-size: calc(14rem / var(--default-rem-px-count));
      font-weight: 500;
      line-height: calc(20rem / var(--default-rem-px-count));
      text-transform: uppercase;
    }

    .header {
      cta-button {
        max-width: calc(220rem / var(--default-rem-px-count));
      }

      .sample-img {
        padding: calc(20rem / var(--default-rem-px-count)) 0;
        max-width: calc(220rem / var(--default-rem-px-count));
      }
    }

    .row {
      width: 100%;

      .row-header {
        font-weight: 500;
      }

      .row-body {
        font-weight: 400;
      }
    }

    .sustainability-downloads {
      .downloads-wrapper {
        padding-top: calc(14rem / var(--default-rem-px-count));
        display: flex;
        flex-direction: column;
        gap: calc(10rem / var(--default-rem-px-count));
      }
    }
  }

  .column {
    border-bottom: 1px solid #cccccc;
  }

  .material-tabs {
    display: flex;
    margin-top: var(--top-padding-height);
    border-bottom: 1px solid #e0e0e0;
  }

  .material-tab {
    display: flex;
    align-items: center;
    height: calc(48rem / var(--default-rem-px-count));
    padding: 0 calc(24rem / var(--default-rem-px-count));
    font-size: var(--fs-body-small);
    line-height: var(--lh-body-small);
    letter-spacing: var(--ls-body-small);
    color: #888888;
    text-decoration: none;
  }

  .material-tab.selected {
    color: #222222;
    box-shadow: inset 0 calc(-2rem / var(--default-rem-px-count)) 0 #222222;
  }

  .material-tabs + #materials-block {
    margin-top: 0;
    border-top: none;
  }

  p {
    /* Some CMS entries have empty <p> tags that are supposed to act as
    line breaks. */
    min-height: 1em;
  }

  @media (min-width: 600px) {
    #materials-block {
      grid-template-columns: repeat(2, 1fr);
    }

    .column {
      border-bottom: unset;
    }

    .column:nth-child(1),
    .column:nth-child(2) {
      border-bottom: 1px solid #cccccc;
    }
  }

  @media (min-width: 1024px) {
    #materials-block {
      grid-template-columns: repeat(4, 1fr);

      .column {
        margin-bottom: unset;
      }
    }

    .column:nth-child(1),
    .column:nth-child(2) {
      border-bottom: unset;
    }
  }

  @media print {
  }
`;
